'use strict';
import * as $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDrawer$002dNavigate$002dTo$00241 from "./app.layouts.-Main-Layout$-Drawer-Navigate-To$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$() {
}
export { $c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$ as $c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$ };
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$.prototype.constructor = $c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$;
/** @constructor */
function $h_Lapp_layouts_MainLayout$DrawerNavigateTo$3$() {
}
export { $h_Lapp_layouts_MainLayout$DrawerNavigateTo$3$ as $h_Lapp_layouts_MainLayout$DrawerNavigateTo$3$ };
$h_Lapp_layouts_MainLayout$DrawerNavigateTo$3$.prototype = $c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$.prototype;
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$.prototype.toString__T = (function() {
  return "DrawerNavigateTo";
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$.prototype.fromProduct__s_Product__Lapp_layouts_MainLayout$DrawerNavigateTo$1 = (function(x$0) {
  var active$1 = x$0.productElement__I__O(0);
  var navigate$1 = x$0.productElement__I__O(1);
  return new $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDrawer$002dNavigate$002dTo$00241.$c_Lapp_layouts_MainLayout$DrawerNavigateTo$1(active$1, navigate$1);
});
$c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_layouts_MainLayout$DrawerNavigateTo$1(p);
});
var $d_Lapp_layouts_MainLayout$DrawerNavigateTo$3$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_layouts_MainLayout$DrawerNavigateTo$3$, "app.layouts.MainLayout$DrawerNavigateTo$3$", ({
  Lapp_layouts_MainLayout$DrawerNavigateTo$3$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_layouts_MainLayout$DrawerNavigateTo$3$ as $d_Lapp_layouts_MainLayout$DrawerNavigateTo$3$ };
//# sourceMappingURL=app.layouts.-Main-Layout$-Drawer-Navigate-To$3$.js.map
